import {MessageModel, MessageStatusesEnum} from '../../libs/shared/core/src/models/api/messageModel';
import {
  noPermission,
  PermissionDeniedReasonsEnum,
  PermissionResult,
  yesPermission,
} from '../../src/helpers/permissionHelpers';

/**
 * Computes a permission based on whether or not the message is sending.
 * (the time between when the user clicked send, and the email actually being sent by the processor).
 */
export function useDestroyMessageMessageSendingPermission(message: MessageModel): PermissionResult {
  const sendingStatus = [MessageStatusesEnum.DRAFT_SENDING, MessageStatusesEnum.DRAFT_PENDING];
  return sendingStatus.includes(message.status)
    ? noPermission(PermissionDeniedReasonsEnum.MESSAGE_SENDING)
    : yesPermission();
}
